import React, { createContext, useState, useContext, useEffect } from 'react';
import { AppContext } from '../../../../../../../Core/App/PageLevel/AppContextProvider';
import { AppStorage } from '../../../../../../../Core/Basic/storage-service';
import { postVehicleJobWheelRemovalAddUpdate, getVehicleJobWheelRemovalGetDetails, downldWheelRemovalGetDetails } from './helpers/wheel-services';

export const WheelAndTorqueContext = createContext(null);

export const WheelAndTorqueProvider = ({ jobID, children, pullData, onClose, handleSteps, isDisabled }) => {
    const appContext = useContext(AppContext);
    const showToast = appContext?.showToast || appContext?.toastState?.showToast;
    const DefaultName = AppStorage.getName();


    const [vehicleDetails, setVehicleDetails] = useState({
        regNo: '',
        vehicleTrailerIDNumber: '',
        serialNumber: ''
    });

    const [wheelRemovalState, setWheelRemovalState] = useState({
        headerRecordID: jobID,
        id: '',
        vehicleTrailerIDNumber: '',
        steerNSAxle1: '',
        steerOSAxle1: '',
        steerOSAxle2: '',
        steerNSAxle2: '',
        driverNSOuterAxle1: '',
        driverNSInnerAxle1: '',
        driverNSOuterAxle2: '',
        driverNSInnerAxle2: '',
        driverOSOuterAxle1: '',
        driverOSInnerAxle1: '',
        driverOSOuterAxle2: '',
        driverOSInnerAxle2: '',
        trailerNSInnerAxle1: '',
        trailerNSOuterAxle1: '',
        trailerOSInnerAxle1: '',
        trailerOSOuterAxle1: '',
        trailerNSInnerAxle2: '',
        trailerNSOuterAxle2: '',
        trailerOSInnerAxle2: '',
        trailerOSOuterAxle2: '',
        trailerNSInnerAxle3: '',
        trailerNSOuterAxle3: '',
        trailerOSInnerAxle3: '',
        trailerOSOuterAxle3: '',
        serialNumber: '',
        createdBy: '',
        signature: '',
        storedSignature: '',
        regNo: '',
        errors: {},
        showDwnldLoader: false
    });

    const [torqueState, setTorqueState] = useState({
        headerRecordID: jobID,
        wheelRetorqueID: null,
        fittingTorque: {
            date: '',
            lbft: null,
            nm: null,
            pn: '',
            time: '',
            vm: null,
            signature: '',
            sign: '',
            reTorqueMileageRequired: null
        },
        reTorque: {
            date: '',
            lbft: null,
            nm: null,
            pn: '',
            time: '',
            vm: null,
            signature: '',
            sign: '',
            additionalReTorqueMileageRequired: null
        },
        showLoader: true
    });

    const [validationErrors, setValidationErrors] = useState({});
    const [submitLoader, setSubmitLoader] = useState(false);
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [loading, setLoading] = useState(true);
    const [hasSavedFittingSignature, setHasSavedFittingSignature] = useState(false);

    const handleDownload = async () => {
        setDownloadLoader(true);
        try {
            await downldWheelRemovalGetDetails(jobID, vehicleDetails.regNo || '');
        } catch (err) {
            console.error('Error in handleDownload:', err);
        } finally {
            setDownloadLoader(false);
        }
    };

    const handleSubmit = async (isSubmit = false) => {
        let wrErrors = {};
        let wrValid = true;
        setWheelRemovalState((prev) => ({ ...prev, errors: wrErrors }));

        let wtErrors = {};
        let wtValid = true;
        if (!torqueState.fittingTorque.nm) {
            wtValid = false;
            wtErrors.fittingTorqueNm = 'Torque value is required.';
        }
        if (!torqueState.fittingTorque.vm) {
            wtValid = false;
            wtErrors.fittingTorqueVm = 'Mileage is required.';
        }
        if (!torqueState.fittingTorque.date) {
            wtValid = false;
            wtErrors.fittingTorqueDate = 'Date is required.';
        }
        if (!torqueState.fittingTorque.pn) {
            wtValid = false;
            wtErrors.fittingTorquePn = 'Name is required.';
        }
        if (!torqueState.fittingTorque.signature) {
            wtValid = false;
            wtErrors.fittingTorqueSign = 'Signature is required.';
        }

        if (isSubmit) {
            if (!torqueState.reTorque.nm) {
                wtValid = false;
                wtErrors.reTorqueNm = 'Torque value is required.';
            }
            if (!torqueState.reTorque.vm) {
                wtValid = false;
                wtErrors.reTorqueVm = 'Mileage is required.';
            }
            if (!torqueState.reTorque.date) {
                wtValid = false;
                wtErrors.reTorqueDate = 'Date is required.';
            }
            if (!torqueState.reTorque.pn) {
                wtValid = false;
                wtErrors.reTorquePn = 'Name is required.';
            }
            if (!torqueState.reTorque.signature) {
                wtValid = false;
                wtErrors.reTorqueSign = 'Signature is required.';
            }
        }

        if (torqueState.fittingTorque.vm && torqueState.reTorque.vm) {
            const fittingMileage = +torqueState.fittingTorque.vm;
            const reTorqueMileage = +torqueState.reTorque.vm;
            if (reTorqueMileage <= fittingMileage) {
                wtValid = false;
                wtErrors.reTorqueVm = 'Re-Torque Mileage must be greater than Torque Mileage.';
            }
        }

        setValidationErrors(wtErrors);

        if (wrValid && wtValid) {
            const payload = {
                VehicleJobWheelJobID: jobID || 0,
                VehicleJobWheelID: wheelRemovalState.id || null,
                VehicleJobWheelRemovalVehicleTrailerIDNumber: vehicleDetails.vehicleTrailerIDNumber || '',

                VehicleJobWheelRemovalSteerNSAxle1: wheelRemovalState.steerNSAxle1 ? +wheelRemovalState.steerNSAxle1 : null,
                VehicleJobWheelRemovalSteerOSAxle1: wheelRemovalState.steerOSAxle1 ? +wheelRemovalState.steerOSAxle1 : null,
                VehicleJobWheelRemovalSteerOSAxle2: wheelRemovalState.steerOSAxle2 ? +wheelRemovalState.steerOSAxle2 : null,
                VehicleJobWheelRemovalSteerNSAxle2: wheelRemovalState.steerNSAxle2 ? +wheelRemovalState.steerNSAxle2 : null,
                VehicleJobWheelRemovalDriverNSOuterAxle1: wheelRemovalState.driverNSOuterAxle1 ? +wheelRemovalState.driverNSOuterAxle1 : null,
                VehicleJobWheelRemovalDriverNSInnerAxle1: wheelRemovalState.driverNSInnerAxle1 ? +wheelRemovalState.driverNSInnerAxle1 : null,
                VehicleJobWheelRemovalDriverNSOuterAxle2: wheelRemovalState.driverNSOuterAxle2 ? +wheelRemovalState.driverNSOuterAxle2 : null,
                VehicleJobWheelRemovalDriverNSInnerAxle2: wheelRemovalState.driverNSInnerAxle2 ? +wheelRemovalState.driverNSInnerAxle2 : null,
                VehicleJobWheelRemovalDriverOSOuterAxle1: wheelRemovalState.driverOSOuterAxle1 ? +wheelRemovalState.driverOSOuterAxle1 : null,
                VehicleJobWheelRemovalDriverOSInnerAxle1: wheelRemovalState.driverOSInnerAxle1 ? +wheelRemovalState.driverOSInnerAxle1 : null,
                VehicleJobWheelRemovalDriverOSOuterAxle2: wheelRemovalState.driverOSOuterAxle2 ? +wheelRemovalState.driverOSOuterAxle2 : null,
                VehicleJobWheelRemovalDriverOSInnerAxle2: wheelRemovalState.driverOSInnerAxle2 ? +wheelRemovalState.driverOSInnerAxle2 : null,
                VehicleJobWheelRemovalTrailerNSInnerAxle1: wheelRemovalState.trailerNSInnerAxle1 ? +wheelRemovalState.trailerNSInnerAxle1 : null,
                VehicleJobWheelRemovalTrailerNSOuterAxle1: wheelRemovalState.trailerNSOuterAxle1 ? +wheelRemovalState.trailerNSOuterAxle1 : null,
                VehicleJobWheelRemovalTrailerOSInnerAxle1: wheelRemovalState.trailerOSInnerAxle1 ? +wheelRemovalState.trailerOSInnerAxle1 : null,
                VehicleJobWheelRemovalTrailerOSOuterAxle1: wheelRemovalState.trailerOSOuterAxle1 ? +wheelRemovalState.trailerOSOuterAxle1 : null,
                VehicleJobWheelRemovalTrailerNSInnerAxle2: wheelRemovalState.trailerNSInnerAxle2 ? +wheelRemovalState.trailerNSInnerAxle2 : null,
                VehicleJobWheelRemovalTrailerNSOuterAxle2: wheelRemovalState.trailerNSOuterAxle2 ? +wheelRemovalState.trailerNSOuterAxle2 : null,
                VehicleJobWheelRemovalTrailerOSInnerAxle2: wheelRemovalState.trailerOSInnerAxle2 ? +wheelRemovalState.trailerOSInnerAxle2 : null,
                VehicleJobWheelRemovalTrailerOSOuterAxle2: wheelRemovalState.trailerOSOuterAxle2 ? +wheelRemovalState.trailerOSOuterAxle2 : null,
                VehicleJobWheelRemovalTrailerNSInnerAxle3: wheelRemovalState.trailerNSInnerAxle3 ? +wheelRemovalState.trailerNSInnerAxle3 : null,
                VehicleJobWheelRemovalTrailerNSOuterAxle3: wheelRemovalState.trailerNSOuterAxle3 ? +wheelRemovalState.trailerNSOuterAxle3 : null,
                VehicleJobWheelRemovalTrailerOSInnerAxle3: wheelRemovalState.trailerOSInnerAxle3 ? +wheelRemovalState.trailerOSInnerAxle3 : null,
                VehicleJobWheelRemovalTrailerOSOuterAxle3: wheelRemovalState.trailerOSOuterAxle3 ? +wheelRemovalState.trailerOSOuterAxle3 : null,

                VehicleJobWheelRemovalSerialNumber: vehicleDetails.serialNumber || '',
                VehicleJobWheelRemovalSignature: wheelRemovalState.signature || null,
                VehicleJobFittingTorqueNutsNN: torqueState.fittingTorque.nm ? +torqueState.fittingTorque.nm : null,
                VehicleJobFittingTorqueNutslbft: torqueState.fittingTorque.lbft ? +torqueState.fittingTorque.lbft : null,
                VehicleJobFittingTorqueMileage: torqueState.fittingTorque.vm ? +torqueState.fittingTorque.vm : null,
                VehicleJobFittingTorqueDateTime: torqueState.fittingTorque.date || null,
                VehicleJobFittingTorqueSignature: torqueState.fittingTorque.signature || null,
                VehicleJobFittingTorqueCreatedBy: torqueState.fittingTorque.pn || '',
                VehicleJobReTorqueNutsNN: torqueState.reTorque.nm ? +torqueState.reTorque.nm : null,
                VehicleJobReTorqueNutslbft: torqueState.reTorque.lbft ? +torqueState.reTorque.lbft : null,
                VehicleJobReTorqueMileage: torqueState.reTorque.vm ? +torqueState.reTorque.vm : null,
                VehicleJobReTorqueMileageRequired: torqueState.fittingTorque.reTorqueMileageRequired ? +torqueState.fittingTorque.reTorqueMileageRequired : null,
                VehicleJobReTorqueDateTime: torqueState.reTorque.date || null,
                VehicleJobReTorqueSignature: torqueState.reTorque.signature || null,
                VehicleJobReTorqueCreatedBy: torqueState.reTorque.pn || ''
            };

            setSubmitLoader(true);
            try {
                let res = await postVehicleJobWheelRemovalAddUpdate(payload);
                if (res && (res.success || res.data?.success)) {
                    showToast(res?.message || res?.data?.message || 'Data saved successfully');
                    if (payload.VehicleJobFittingTorqueSignature) {
                        setHasSavedFittingSignature(true);
                    }
                    pullData && pullData();
                    onClose && onClose();
                    handleSteps && handleSteps(3);
                } else {
                    const errors = res?.errors || res?.data?.errors;
                    if (errors) {
                        for (const [key, value] of Object.entries(errors)) {
                            showToast(`${key}: ${value}`);
                        }
                    } else {
                        showToast(res?.message || res?.data?.message);
                    }
                }
            } catch (err) {
                console.error(err);
                showToast('An error occurred while saving.');
            } finally {
                setSubmitLoader(false);
            }
        }
    };

    useEffect(() => {
        const loadDetails = async () => {
            if (!jobID) {
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                let res = await getVehicleJobWheelRemovalGetDetails(jobID);
                if (res.success) {
                    let data = res.data.data;
                    if (Array.isArray(data)) {
                        data = data[0];
                    }
                    data = data || {};
                    const getValue = (obj, key) => {
                        if (!obj) return null;
                        const lowerKey = key.toLowerCase();
                        const foundKey = Object.keys(obj).find(k => k.toLowerCase() === lowerKey);
                        return foundKey ? obj[foundKey] : null;
                    };

                    const id = getValue(data, 'id');
                    const vehicleTrailerIDNumber = getValue(data, 'vehicleTrailerIDNumber') || '';
                    const serialNumber = getValue(data, 'vehicleJobWheelRemovalSerialNumber') || '';
                    const regNo = getValue(data, 'reg') || '';

                    setVehicleDetails({
                        regNo,
                        vehicleTrailerIDNumber,
                        serialNumber
                    });

                    setWheelRemovalState((st) => ({
                        ...st,
                        id,
                        vehicleTrailerIDNumber,
                        serialNumber,
                        regNo,
                        steerNSAxle1: getValue(data, 'steerNSAxle1') ?? '',
                        steerOSAxle1: getValue(data, 'steerOSAxle1') ?? '',
                        steerOSAxle2: getValue(data, 'steerOSAxle2') ?? '',
                        steerNSAxle2: getValue(data, 'steerNSAxle2') ?? '',
                        driverNSOuterAxle1: getValue(data, 'driverNSOuterAxle1') ?? '',
                        driverNSInnerAxle1: getValue(data, 'driverNSInnerAxle1') ?? '',
                        driverNSOuterAxle2: getValue(data, 'driverNSOuterAxle2') ?? '',
                        driverNSInnerAxle2: getValue(data, 'driverNSInnerAxle2') ?? '',
                        driverOSOuterAxle1: getValue(data, 'driverOSOuterAxle1') ?? '',
                        driverOSInnerAxle1: getValue(data, 'driverOSInnerAxle1') ?? '',
                        driverOSOuterAxle2: getValue(data, 'driverOSOuterAxle2') ?? '',
                        driverOSInnerAxle2: getValue(data, 'driverOSInnerAxle2') ?? '',
                        trailerNSInnerAxle1: getValue(data, 'trailerNSInnerAxle1') ?? '',
                        trailerNSOuterAxle1: getValue(data, 'trailerNSOuterAxle1') ?? '',
                        trailerOSInnerAxle1: getValue(data, 'trailerOSInnerAxle1') ?? '',
                        trailerOSOuterAxle1: getValue(data, 'trailerOSOuterAxle1') ?? '',
                        trailerNSInnerAxle2: getValue(data, 'trailerNSInnerAxle2') ?? '',
                        trailerNSOuterAxle2: getValue(data, 'trailerNSOuterAxle2') ?? '',
                        trailerOSInnerAxle2: getValue(data, 'trailerOSInnerAxle2') ?? '',
                        trailerOSOuterAxle2: getValue(data, 'trailerOSOuterAxle2') ?? '',
                        trailerNSInnerAxle3: getValue(data, 'trailerNSInnerAxle3') ?? '',
                        trailerNSOuterAxle3: getValue(data, 'trailerNSOuterAxle3') ?? '',
                        trailerOSInnerAxle3: getValue(data, 'trailerOSInnerAxle3') ?? '',
                        trailerOSOuterAxle3: getValue(data, 'trailerOSOuterAxle3') ?? '',
                        createdBy: getValue(data, 'removalCreatedBy') || '',
                        signature: getValue(data, 'vehicleJobWheelRemovalSignature') || '',
                        storedSignature: getValue(data, 'vehicleJobWheelRemovalSignature') || ''
                    }));

                    const fittingSig = getValue(data, 'fittingTorqueSignature') || '';
                    if (fittingSig) {
                        setHasSavedFittingSignature(true);
                    }

                    setTorqueState((st) => ({
                        ...st,
                        wheelRetorqueID: id,
                        fittingTorque: {
                            ...st.fittingTorque,
                            date: getValue(data, 'fittingTorqueDateTime') || '',
                            lbft: getValue(data, 'fittingTorqueNutslbft') ?? null,
                            nm: getValue(data, 'fittingTorqueNutsNN') ?? null,
                            pn: getValue(data, 'fittingTorqueCreatedBy') || '',
                            vm: getValue(data, 'fittingTorqueMileage') ?? null,
                            signature: fittingSig,
                            sign: fittingSig,
                            reTorqueMileageRequired: getValue(data, 'reTorqueMileageRequired') ?? null
                        },
                        reTorque: {
                            ...st.reTorque,
                            date: getValue(data, 'reTorqueDateTime') || '',
                            lbft: getValue(data, 'reTorqueNutslbft') ?? null,
                            nm: getValue(data, 'reTorqueNutsNN') ?? null,
                            pn: getValue(data, 'reTorqueCreatedBy') || '',
                            vm: getValue(data, 'reTorqueMileage') ?? null,
                            signature: getValue(data, 'reTorqueSignature') || '',
                            sign: getValue(data, 'reTorqueSignature') || '',
                            additionalReTorqueMileageRequired: null
                        },
                        showLoader: false
                    }));
                }
            } catch (err) {
                console.error('Error fetching Wheel Torque details:', err);
            } finally {
                setLoading(false);
            }
        };
        loadDetails();
    }, [jobID]);

    return (
        <WheelAndTorqueContext.Provider value={{
            vehicleDetails, setVehicleDetails,
            wheelRemovalState, setWheelRemovalState,
            torqueState, setTorqueState,
            validationErrors, setValidationErrors,
            headerId: jobID,
            DefaultName,
            submitLoader,
            handleSubmit,
            downloadLoader,
            handleDownload,
            isDisabled,
            loading,
            hasSavedFittingSignature
        }}>
            {children}
        </WheelAndTorqueContext.Provider>

    );
};
